



























































































































































































































import Vue from "vue";
import store, { AccountTypeStore } from "../services/AccountTypeStore";
import Page from "../../../components/Page.vue";
import AccountType from "../models/AccountType";
import { t } from "@/plugins/i18n";

interface Data {
  store: AccountTypeStore;
}
export default Vue.extend<Data, {}, {}, {}>({
  components: {
    Page,
  },

  data(): Data {
    return {
      store,
    };
  },

  async beforeMount() {
    await this.store.loadAccountTypes();
  },

  computed: {
    columns: () => [
      { field: "name", title: t("Megnevezes") },
      {
        field: "default",
        title: t("Alapert"),
        cell: "defaultTemplate",
        editor: "boolean",
      },
      {
        field: "isIn",
        title: t("AccountType_JovairasLehet"),
        cell: "isInTemplate",
        editor: "boolean",
      },
      {
        field: "isOut",
        title: t("AccountType_TerhelesLehet"),
        cell: "isOutTemplate",
        editor: "boolean",
      },
      {
        field: "isInvoice",
        title: t("AccountType_SzlaKiegy_2"),
        cell: "isInvoiceTemplate",
        editor: "boolean",
      },
      {
        field: "isCred",
        title: t("AccountType_Hitelatvezetes"),
        cell: "isCredTemplate",
        editor: "boolean",
      },
      {
        field: "isOver",
        title: t("AccountType_TulfizRend"),
        cell: "isOverTemplate",
        editor: "boolean",
      },
      {
        field: "isTech",
        title: t("AccountType_TechFizAtvezetes"),
        cell: "isTechTemplate",
        editor: "boolean",
      },
      {
        field: "isDeb",
        title: t("AccountType_BeszedMegbTipusu_2"),
        cell: "isDebTemplate",
        editor: "boolean",
      },
      {
        field: "isGeni",
        title: t("AccountType_BeszedMegbGENI_2"),
        cell: "isGeniTemplate",
        editor: "boolean",
      },
      { cell: "commandTemplate", width: "100px" },
    ],

    items() {
      return this.store.accountTypes;
    },
  },

  methods: {
    deleteAccountType(item: AccountType) {
      this.store.deleteAccountType(item.id);
    },

    showDetails(item: AccountType) {
      this.$router.push(`/account/account-type/${item.id}/details`);
    },

    editItem(item: AccountType) {
      this.store.setEditing(item);
    },

    itemChange({
      dataItem,
      value,
      field,
    }: {
      dataItem: AccountType;
      value: any;
      field: string;
    }) {
      const item = dataItem;
      const update = {
        [field]: value,
      };

      this.store.save(item, update);
    },

    cancelEdit(item: AccountType) {
      item.inEdit = false;
      this.store.saveAccountType(this.store.accountType);
    },
  },
});
